import { SELECT_NETWORK } from '../actions';

export default (state = null, action) => {
  switch (action.type) {
    case SELECT_NETWORK:
      return action.networkId;
    default: return state;
  }
};
